<template>
  <div class="aw-consult">
    <div class="com-sub-top">
      <div class="title container-center">售前支持</div>
    </div>
    <div class="pre-box">
      <div class="pre-text">
        <p>您还可通过以下渠道与我们建立联系！</p>
        <p class="pre-sub-title">客服电话</p>
        <p class="pre-desc">4000-365-805</p>
        <p class="pre-sub-title">商务合作</p>
        <p class="pre-desc">sales@awcloud.com</p>
        <p class="pre-sub-title">技术支持</p>
        <p class="pre-desc">support@awcloud.com</p>
        <p class="pre-sub-title">市场宣传</p>
        <p class="pre-desc">marketing@awcloud.com</p>
      </div>
      <div class="consult-list middle-dialog">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="98px"
          label-position="left"
          class="com-ruleForm"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="手机" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入" @input="isExist" ></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="vfCode">
            <el-input v-model="ruleForm.vfCode" placeholder="请输入" :disabled="!isPhoneExist"></el-input>
            <div v-if="!isSendMail" class="verify-code-show">验证码已发送至{{ruleForm.phone}},5分钟内有效</div>
            <div v-if="!isPhoneExist" class=""><img src="@/assets/preSales/success.svg" alt=""> 已认证用户，无需重复验证</div>
            <span
              v-if="isPhoneExist"
              :class="['verify-code-mail', { 'resend-style': !isSendMail }]"
              @click="getEmailCode"
            >
              {{ showSendMailText }}
            </span>
          </el-form-item>
          <el-form-item label="公司" prop="company">
            <el-input
              v-model="ruleForm.company"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="职位" prop="position">
            <el-input
              v-model="ruleForm.position"
              placeholder="请输入"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="ruleForm.email" placeholder="请输入"></el-input>
          </el-form-item>
          <div class="com-tab-box">
            <div class="p-box">
              <div></div>
              <p :class="{ active: key == '1' }" @click="choose('1')">
                业务咨询
              </p>
              <p :class="{ active: key == '2' }" @click="choose('2')">
                产品文档下载
              </p>
              <div></div>
            </div>
          </div>
          <el-form-item label="业务需求描述" prop="businessDescription" v-if="key=='1'">
            <el-input
              v-model="ruleForm.businessDescription"
              type="textarea"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="key=='1'"
            class="consult-label"
            label="方便沟通的时间段"
            prop="desc"
          >
            <template #label>
                <div class="custom-label">
                    <span>方便沟通的时间段</span>
                    <div class="muli-style">(可多选)</div>
                </div>
            </template>
            <div>周一至周五</div>
            <el-checkbox-group v-model="ruleForm.workdayList">
              <el-checkbox label="1" >上午</el-checkbox>
              <el-checkbox label="2" >中午</el-checkbox>
              <el-checkbox label="3" >下午</el-checkbox>
            </el-checkbox-group>
            <div class="weekend-dash">周末</div>
            <el-checkbox-group v-model="ruleForm.holidayList">
              <el-checkbox label="4" >上午</el-checkbox>
              <el-checkbox label="5" >中午</el-checkbox>
              <el-checkbox label="6" >下午</el-checkbox>
            </el-checkbox-group>
            <el-input
              v-model="ruleForm.preferredHours"
              placeholder="可备注偏好的具体小时范围,便于安排顾问对接"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="key=='2'"
            class="consult-label"
            label="选择文档 "
            prop="desc"
          >
            <template #label>
                <div class="custom-label">
                    <span>选择文档</span>
                    <div class="muli-style">(可多选)</div>
                </div>
            </template>
            <el-checkbox-group v-model="ruleForm.docList">
              <el-checkbox :label="item.id" v-for="(item,index) in docArry" :key="index">{{item.title}}</el-checkbox>
              <!-- <el-checkbox label="1">云计算产品手册</el-checkbox>
              <el-checkbox label="2">人工智能产品集</el-checkbox>
              <el-checkbox label="3">物联网&边缘计算产品集</el-checkbox>
              <el-checkbox label="4">教育实训产品集</el-checkbox>
              <el-checkbox label="5">案例集</el-checkbox> -->
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            label-width="0px"
            label=""
            class="checked-desc"
            prop="checked"
          >
            <el-checkbox v-model="ruleForm.checked" prop="checked"></el-checkbox
            >我已阅读并同意海云捷迅<span
              class="red-text"
              @click="showProtocol(1)"
              >《法律声明》</span
            >、<span class="red-text" @click="showProtocol(2)"
              >《隐私政策》</span
            >及<span class="red-text" @click="showProtocol(3)"
              >用户管理规则及公约</span
            >
          </el-form-item>
          <div class="checked-btn" @click="submitForm('ruleForm')">提交</div>
          <el-dialog
            class="aw-doc"
            :width="dialogWidth"
            :close-on-click-modal="false"
            title=""
            :visible.sync="innerVisible"
            append-to-body
          >
            <aw-protocol :showCase="showCase" v-show="!showSuccess"></aw-protocol>
            <div class="success-info" v-show="showSuccess"><img src="@/assets/preSales/support_icon_success.png" alt="">提交成功</div>
          </el-dialog>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { sendCode, sendConsultation, verifyCode, queryPhone, queryDocList } from "@/api/common.js";
import { debounce } from "lodash";
import awProtocol from "./protocol.vue";
// import { Notification } from 'element-ui';
export default {
  components: {
    awProtocol,
  },
  data() {
    const checkedProtocol = (rule, value, callback) => {
      if (value) {
        callback();
      } else {
        callback(new Error("请勾选注册协议"));
      }
    };
    return {
      dialogWidth: '520px',
      key: "1",
      ruleForm: {
        name: "",
        phone: "",
        vfCode: "",
        company: "",
        position: "",
        businessDescription: "",
        email: "",
        checked: false,
        workdayList: [],
        holidayList: [],
        preferredHours: "",
        docList: []
      },
      docArry: [],
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 5,
            message: "长度在 2 到 5 个字符",
            trigger: "change",
          },
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/,
            message: "姓名只能包含中英文",
            trigger: "change",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "change" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "change",
          },
        ],
        vfCode: [
          { required: true, message: "请输入验证码", trigger: "change" },
          { pattern: /^\d+$/, message: "请输入数字", trigger: "change" },
        ],
        company: [
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/,
            required: true,
            message: "公司名称只能包含中英文和数字",
            trigger: "change",
          },
        ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: "change",
          },
        ],
        checked: [
          {
            required: true,
            validator: checkedProtocol,
            message: "请勾选使用协议",
          },
        ],
        notes: [
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/,
            message: "请输入中文、英文、数字",
            trigger: "change",
          },
        ],
      },
      isSendMail: true,
      timer: null,
      // 倒计时
      countdown: "",
      // 倒计时时间
      TIME_COUNT: 300,

      innerVisible: false,
      showCase: 1,
      showSuccess: false,
      isPhoneExist: true
    };
  },
  methods: {
    submitForm: debounce(function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let {
            name,
            phone,
            vfCode,
            company,
            email,
            businessDescription,
            holidayList,
            workdayList,
            preferredHours,
            docList
          } = this.ruleForm;
          let preferredTime = [...workdayList, ...holidayList];
          let params = {
            name,
            phone,
            company,
            email,
            businessDescription,
            preferredTime: preferredTime.join(","),
            preferredHours,
          };
          if(this.key == '2'){
            console.log(params);
            params.documentSelections =  docList.join(",")
          }
          if(this.isPhoneExist) {
              verifyCode({ mobile: phone, code: vfCode }).then((res) => {
                if (res && res.code == 200) {
                  this.submitConsultation(params)
                }
              });
          }else {
            this.submitConsultation(params)
          }
        }
      });
    }, 500),
    getEmailCode: debounce(function () {
      if (this.isSendMail) {
        // 单独校验手机号字段
        this.$refs.ruleForm.validateField("phone", (valid) => {
          if (!valid) {
            sendCode({ mobile: this.ruleForm.phone }).then((res) => {
              if (res && res.code == 200) {
                this.TIME_COUNT = 300;
                this.isSendMail = false;
              }
            });
          }
        });
      }
    }, 500),
    showProtocol(val) {
      this.showSuccess = false
      this.showCase = val;
      this.innerVisible = true;
    },
    choose(val) {
        this.key = val;
    },
    isExist(val) {
        const phoneRegex = /^1[3-9]\d{9}$/;
        if (phoneRegex.test(val)) {
            // 手机号格式正确，调接口判断是否存在，存在就把必填校验取消
            queryPhone({phone: val}).then(res => {
                if(res && res.code==200) {
                    // Notification({
                    //     title: '提示',
                    //     message: '已自动根据手机号关联信息',
                    //     duration: 3000,
                    //     type: "success",
                    //     customClass: "success"
                    // });
                    this.isPhoneExist = false
                    let { name, company, email } = res.data
                    this.ruleForm = {
                        ...this.ruleForm,
                        name,
                        company,
                        email
                    }
                }else {
                    this.isPhoneExist = true
                }
                // this.rules.name[0].required = this.isPhoneExist
                // this.rules.phone[0].required = this.isPhoneExist
                this.rules.vfCode[0].required = this.isPhoneExist
                // this.rules.company[0].required = this.isPhoneExist
            })
        }else {
            this.isPhoneExist = true
            // this.rules.name[0].required = this.isPhoneExist
            // this.rules.phone[0].required = this.isPhoneExist
            this.rules.vfCode[0].required = this.isPhoneExist
            // this.rules.company[0].required = this.isPhoneExist
        }
        
    },
    queryDoc() {
        queryDocList().then(res => {
            if(res && res.code == 200) {
                this.docArry = res.data
            }
        })
    },
    submitConsultation(params) {
        sendConsultation(params).then((res) => {
            if(res && res.code == 200) {
                this.showSuccess = true
                this.innerVisible = true;
                if(res.data) {
                     res.data.forEach((item, index) => {
                        // 使用setTimeout来创建延迟效果，每隔2秒下载一个文件
                        setTimeout(() => {
                            this.autoDownload(item.downloadUrl);
                        }, index * 2000); // 每个文件之间间隔2秒
                    });
                }
                this.$refs.ruleForm.resetFields();
            }
        });
    },
    autoDownload(url) {
      const link = document.createElement('a');
      link.href = url;
      link.download = decodeURIComponent(url.substring(url.lastIndexOf('/') + 1)); // 从URL中提取并解码文件名
      document.body.appendChild(link);
      link.target = "_blank";
      link.click(); // 触发下载
      document.body.removeChild(link); // 移除链接元素
    },
    isMobileScreen() {
        if(window.innerWidth <= 768) {
            this.dialogWidth = '360px'
        }else {
            this.dialogWidth = '520px'
        }
    }
  },
  computed: {
    showSendMailText() {
      if (this.isSendMail) {
        return "获取验证码";
      } else {
        if (!this.timer) {
          this.countdown = this.TIME_COUNT;
          this.timer = setInterval(() => {
            if (this.countdown > 0 && this.countdown <= this.TIME_COUNT) {
              this.countdown--;
            } else {
              this.isSendMail = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
        return `重新发送${this.countdown}`; // `重新发送(${this.countdown})`
      }
    },
  },
  mounted() {
    this.isMobileScreen()
    this.queryDoc()
  },
};
</script>